import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Tab, Row, Col, Nav } from "react-bootstrap";
// Import images
import FoodDeliveryImage from "../../assets/images/food-delivery-app.jpg";
import EcommerceImage from "../../assets/images/food-delivery-app.jpg";
import ChatAppImage from "../../assets/images/food-delivery-app.jpg";
import TaxiBookingImage from "../../assets/images/food-delivery-app.jpg";
import AppointmentBookingImage from "../../assets/images/food-delivery-app.jpg";
import BannerImg from "../../assets/images/banner-img.jpg";
import AboutImg from "../../assets/images/about-img.jpg";
import Delivery1 from "../../assets/images/delivery/delivery-1.png";
import Delivery2 from "../../assets/images/delivery/delivery-2.png";
import Delivery3 from "../../assets/images/delivery/delivery-3.png";
import Delivery4 from "../../assets/images/delivery/delivery-4.png";
import Delivery5 from "../../assets/images/delivery/delivery-5.png";
import Delivery6 from "../../assets/images/delivery/delivery-6.png";
import Delivery7 from "../../assets/images/delivery/delivery-7.png";
import Delivery8 from "../../assets/images/delivery/delivery-8.png";
import Delivery9 from "../../assets/images/delivery/delivery-9.png";
import Delivery10 from "../../assets/images/delivery/delivery-10.png";
import Delivery11 from "../../assets/images/delivery/delivery-11.png";
import Delivery12 from "../../assets/images/delivery/delivery-12.png";
import Delivery13 from "../../assets/images/delivery/delivery-13.png";

import Customer1 from "../../assets/images/customer/customer-1.jpg";
import Customer2 from "../../assets/images/customer/customer-2.jpg";
import Customer3 from "../../assets/images/customer/customer-3.jpg";
import Customer4 from "../../assets/images/customer/customer-4.jpg";
import Customer5 from "../../assets/images/customer/customer-5.jpg";
import Customer6 from "../../assets/images/customer/customer-6.jpg";
import Customer7 from "../../assets/images/customer/customer-7.jpg";
import Customer8 from "../../assets/images/customer/customer-8.jpg";
import Customer9 from "../../assets/images/customer/customer-9.jpg";
import Customer10 from "../../assets/images/customer/customer-10.jpg";
import Customer11 from "../../assets/images/customer/customer-11.jpg";
import Customer12 from "../../assets/images/customer/customer-12.jpg";
import Customer13 from "../../assets/images/customer/customer-13.jpg";
import Customer14 from "../../assets/images/customer/customer-14.jpg";
import Customer15 from "../../assets/images/customer/customer-15.jpg";
import Customer16 from "../../assets/images/customer/customer-16.jpg";
import Customer17 from "../../assets/images/customer/customer-17.jpg";
import Customer18 from "../../assets/images/customer/customer-18.jpg";
import Customer19 from "../../assets/images/customer/customer-19.jpg";
import Customer20 from "../../assets/images/customer/customer-20.jpg";
import Customer21 from "../../assets/images/customer/customer-21.jpg";
import Customer22 from "../../assets/images/customer/customer-22.jpg";
import Customer23 from "../../assets/images/customer/customer-23.jpg";
import Customer24 from "../../assets/images/customer/customer-24.jpg";
import Customer25 from "../../assets/images/customer/customer-25.jpg";

import Admin1 from "../../assets/images/admin/admin-1.png";
import Admin2 from "../../assets/images/admin/admin-2.png";
import Admin3 from "../../assets/images/admin/admin-3.png";
import Admin4 from "../../assets/images/admin/admin-4.png";
import Admin5 from "../../assets/images/admin/admin-5.png";
import Admin6 from "../../assets/images/admin/admin-6.png";
import Admin7 from "../../assets/images/admin/admin-7.png";
import Admin8 from "../../assets/images/admin/admin-8.png";
import Admin9 from "../../assets/images/admin/admin-9.png";
import Admin10 from "../../assets/images/admin/admin-10.png";
import Admin11 from "../../assets/images/admin/admin-11.png";
import Admin12 from "../../assets/images/admin/admin-12.png";
import Admin13 from "../../assets/images/admin/admin-13.png";
import Admin14 from "../../assets/images/admin/admin-14.png";
import Admin15 from "../../assets/images/admin/admin-15.png";
import Admin16 from "../../assets/images/admin/admin-16.png";
import Admin17 from "../../assets/images/admin/admin-17.png";
import Admin18 from "../../assets/images/admin/admin-18.png";
import Admin19 from "../../assets/images/admin/admin-19.png";
import Admin20 from "../../assets/images/admin/admin-20.png";
import Admin21 from "../../assets/images/admin/admin-21.png";
import Admin22 from "../../assets/images/admin/admin-22.png";
import Admin23 from "../../assets/images/admin/admin-23.png";
import Admin24 from "../../assets/images/admin/admin-24.png";
import Admin25 from "../../assets/images/admin/admin-25.png";
import Admin26 from "../../assets/images/admin/admin-26.png";
import Admin27 from "../../assets/images/admin/admin-27.png";
import Admin28 from "../../assets/images/admin/admin-28.png";
import Admin29 from "../../assets/images/admin/admin-29.png";
import Admin30 from "../../assets/images/admin/admin-30.png";

import ServiceImg from "../../assets/images/about-img.jpg";
import BlogImg1 from "../../assets/images/blogs/blog-1.jpg";
import BlogImg2 from "../../assets/images/blogs/blog-2.jpg";
import BlogImg3 from "../../assets/images/blogs/blog-3.jpg";

import { Link } from "react-router-dom";
import Video1 from "../../assets/images/client-testimonial.mp4";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const HomeSec = () => {
  const sliderSettings1 = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const sliderSettings2 = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const sliderSettings3 = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const images1 = {
    admin: [
      Admin1,
      Admin2,
      Admin3,
      Admin4,
      Admin5,
      Admin6,
      Admin7,
      Admin8,
      Admin9,
      Admin10,
      Admin11,
      Admin12,
      Admin13,
      Admin14,
      Admin15,
      Admin16,
      Admin17,
      Admin18,
      Admin19,
      Admin20,
      Admin21,
      Admin22,
      Admin23,
      Admin24,
      Admin25,
      Admin26,
      Admin27,
      Admin28,
      Admin29,
      Admin30,
    ],
    customer: [
      Customer1,
      Customer2,
      Customer3,
      Customer4,
      Customer5,
      Customer6,
      Customer7,
      Customer8,
      Customer9,
      Customer10,
      Customer11,
      Customer12,
      Customer13,
      Customer14,
      Customer15,
      Customer16,
      Customer17,
      Customer18,
      Customer19,
      Customer20,
      Customer21,
      Customer22,
      Customer23,
      Customer24,
      Customer25,
    ],
    delivery: [
      Delivery1,
      Delivery2,
      Delivery3,
      Delivery4,
      Delivery5,
      Delivery6,
      Delivery7,
      Delivery8,
      Delivery9,
      Delivery10,
      Delivery11,
      Delivery12,
      Delivery13,
    ],
  };

  const slides = [
    {
      title: "Food Delivery App",
      subtitle: "Deliciously Delivered, Anytime, Anywhere",
      content:
        "Transform the way food is delivered with our dynamic Food Delivery App. Designed to offer convenience and efficiency, this app ensures customers can browse menus, place orders, and track deliveries in real time. With features like secure payment options, user-friendly navigation, and personalized experiences, you can create a seamless journey from kitchen to doorstep.",
      cta: "Order Now",
      image: FoodDeliveryImage,
    },
    {
      title: "E-Commerce Website",
      subtitle: "Find everything you need at unbeatable prices.",
      content:
        "Empower your business with a cutting-edge E-Commerce Website that drives sales and enhances brand visibility. Our solutions focus on providing a smooth shopping experience, complete with advanced product management, secure transactions, and engaging designs. Perfect for startups and established businesses alike, this platform is your gateway to online success.",
      cta: "Start Shopping",
      image: EcommerceImage,
    },
    {
      title: "Chat App",
      subtitle: "Stay in touch with friends and family like never before.",
      content:
        "Stay connected with our feature-rich Chat App, designed for real-time communication. Whether for personal or professional use, this app ensures secure messaging, group conversations, and high-quality video calls. Tailored to your needs, it’s the ideal solution for fostering collaboration and strengthening relationships.",
      cta: "Get Started",
      image: ChatAppImage,
    },
    {
      title: "Taxi Booking App",
      subtitle: "Your reliable ride is just a tap away!",
      content:
        "Streamline transportation with our Taxi Booking App, built to deliver convenience and reliability. Users can effortlessly book rides, track drivers in real time, and make secure payments, all within a few taps. With advanced features and a focus on user experience, this app ensures smoother journeys for passengers and better management for drivers.",
      cta: "Book a Ride",
      image: TaxiBookingImage,
    },
    {
      title: "Appointment Booking App",
      subtitle: "Book appointments with your favorite services in no time.",
      content:
        "Optimize scheduling with our Appointment Booking App, crafted for businesses and their clients. This app simplifies booking processes, sends timely reminders, and integrates seamlessly with calendars to enhance productivity. Whether for healthcare, salons, or other services, this solution is a perfect fit for modern-day scheduling needs.",
      cta: "Book Now",
      image: AppointmentBookingImage,
    },
  ];

  const testimonials = [
    {
      id: 1,
      videoUrl: Video1,
    },
    {
      id: 2,
      videoUrl: Video1,
    },
    {
      id: 3,
      videoUrl: Video1,
    },
  ];

  const sliderRef = useRef(null);

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3, // Show 3 slides for large screens
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2, // Show 2 slides for medium screens
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1, // Show 1 slide for smaller screens
        },
      },
    ],
  };

  return (
    <>
      <div className="banner-sec py-5">
        {/* <Swiper
          direction="vertical"
          spaceBetween={0}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          autoplay={{
            delay: 3000, // Auto slide interval in ms (3 seconds)
            disableOnInteraction: false, // Prevents the autoplay from stopping after interaction
          }}
          mousewheel={true}
          modules={[Navigation, Pagination, Autoplay]} // Add Autoplay module
          className="swiper-container"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="row h-100">
                <div className="col-lg-6 p-0">
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="slide-image"
                  />
                </div>
                <div className="col-lg-6 p-0">
                  <div
                    className="slide-content"
                    style={{ backgroundColor: slide.backgroundColor }}
                  >
                    <div className="title">
                      <h4>{slide.subtitle}</h4>
                      <h2>{slide.title}</h2>
                      <p className="slide-text">{slide.content}</p>
                      <Link to="/" className="btn btn-primary">
                        {slide.cta}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper> */}
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="title mb-5">
                <h4 className="text-center">
                  Best Mobile Application Development Agency
                </h4>
                <h1 className="text-center">About the CodeInfoWay</h1>
                {/* <p className="text-center">
                  Our mission is to help you achieve your goals by consulting
                  on, creating and maintaining custom software and apps that
                  makes a real and positive difference in your business.
                </p> */}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <img src={BannerImg} alt="Banner Image" />
            </div>
          </div>
        </div>
      </div>

      <div className="our-mission">
        <div className="title bg-dark py-5 px-5 mb-5 position-relative">
          <h4 className="text-center">Driving Innovation, Empowering Growth</h4>
          <h2 className="text-white text-center">Our Commitment to Success</h2>
          <div className="down-arrow">
            <FontAwesomeIcon icon={faPlay} />
          </div>
        </div>
      </div>

      <div className="about-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 about-left">
              <div className="about-img w-75 mx-auto">
                <img src={AboutImg} alt="about image" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <h4>Best Mobile Application Development Agency</h4>
                <h2>About the CodeInfoWay</h2>
                <p>
                  Our mission is to help you achieve your goals by consulting
                  on, creating and maintaining custom software and apps that
                  makes a real and positive difference in your business.
                </p>
                <p>
                  We want to offer our clients only those features and options
                  we know will be valuable to your business. Our goal is not to
                  max out the budget, rather to learn as much as we can about
                  our clients and their businesses, then propose the most
                  appropriate service.What we do is based on common sense, not
                  ethics. You will pay for what you want and will get it with no
                  further questions, which is why we will be straightforward
                  with you and find win-win solutions.
                </p>
                <Link to="/about-us" className="btn btn-primary">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="achivement-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title">
                <h4>Celebrating Milestones and Recognizing Excellence</h4>
                <h2>Our Achivements</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <p>
                  We take pride in delivering impactful solutions and building long-term
                  relationships with our clients. Our journey is defined by innovation,
                  dedication, and a commitment to excellence. From successful project
                  deliveries to a growing team of skilled professionals, every milestone
                  reflects our passion for creating high-quality digital experiences.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-3 col-md-6">
              <div className="box box-dark">
                <h3>10+</h3>
                <h5>Our Team</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="box box-dark">
                <h3>65+</h3>
                <h5>completed Project</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="box box-dark">
                <h3>50+</h3>
                <h5>Mobile Apps</h5>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="box box-dark">
                <h3>15+</h3>
                <h5>Web Apps</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title">
                <h4>Innovative Solutions, Exceptional Results</h4>
                <h2>Our Services</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <p>
                  Our services are designed to cater to your unique needs,
                  offering innovative and reliable solutions that drive success.
                  From cutting-edge technology to personalized support, we are
                  committed to delivering excellence and helping you achieve
                  your goals seamlessly.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-0 mt-lg-5">
            <div className="col-lg-12">
              <Tab.Container defaultActiveKey="service1">
                <Row className="mt-3 align-items-center">
                  <Col sm={4}>
                    <Nav variant="pills" className="flex-column service-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="service1">
                          01 React Native Development
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="service2">
                          02 IOS App Development
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="service3">
                          03 Android App Development
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="service4">
                          04 iPad & Tablet Solutions
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="service5">
                          05 Flutter Development
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                  <Col sm={8}>
                    <Tab.Content>
                      <Tab.Pane eventKey="service1">
                        <div className="row align-items-center">
                          <div className="col-lg-6">
                            <div className="service-box">
                              <span className="stepno">01</span>
                              <h4>React Native Development</h4>
                              <p>
                                Build powerful and scalable mobile applications
                                with React Native, delivering a seamless
                                experience for both iOS and Android platforms
                                with a single codebase.
                              </p>
                              <Link
                                to="/react-native"
                                className="btn btn-primary"
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                          <div className="col-lg-6 service-right">
                            <div className="service-img w-100 mx-auto">
                              <img src={ServiceImg} alt="React Native Image" />
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="service2">
                        <div className="row align-items-center">
                          <div className="col-lg-6">
                            <div className="service-box">
                              <span className="stepno">02</span>
                              <h4>iOS App Development</h4>
                              <p>
                                Create engaging and intuitive iOS applications
                                tailored for the Apple ecosystem, ensuring high
                                performance and user satisfaction.
                              </p>
                              <Link to="/ios" className="btn btn-primary">
                                Read More
                              </Link>
                            </div>
                          </div>
                          <div className="col-lg-6 service-right">
                            <div className="service-img w-100 mx-auto">
                              <img src={ServiceImg} alt="React Native Image" />
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="service3">
                        <div className="row align-items-center">
                          <div className="col-lg-6">
                            <div className="service-box">
                              <span className="stepno">03</span>
                              <h4>Android App Development</h4>
                              <p>
                                Deliver feature-rich Android apps that provide
                                exceptional user experiences, leveraging the
                                latest technologies and frameworks.
                              </p>
                              <Link to="/android" className="btn btn-primary">
                                Read More
                              </Link>
                            </div>
                          </div>
                          <div className="col-lg-6 service-right">
                            <div className="service-img w-100 mx-auto">
                              <img src={ServiceImg} alt="React Native Image" />
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="service4">
                        <div className="row align-items-center">
                          <div className="col-lg-6">
                            <div className="service-box">
                              <span className="stepno">04</span>
                              <h4>iPad & Tablet Solutions</h4>
                              <p>
                                Develop optimized applications for iPads and
                                tablets, ensuring adaptability and functionality
                                across larger screens for a superior user
                                experience.
                              </p>
                              <Link
                                to="ipad-tablet"
                                className="btn btn-primary"
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                          <div className="col-lg-6 service-right">
                            <div className="service-img w-100 mx-auto">
                              <img src={ServiceImg} alt="React Native Image" />
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="service5">
                        <div className="row align-items-center">
                          <div className="col-lg-6">
                            <div className="service-box">
                              <span className="stepno">05</span>
                              <h4>Flutter Development</h4>
                              <p>
                                Leverage the power of Flutter to create stunning
                                cross-platform applications with a focus on
                                speed, efficiency, and beautiful UI designs.
                              </p>
                              <Link to="/flutter" className="btn btn-primary">
                                Read More
                              </Link>
                            </div>
                          </div>
                          <div className="col-lg-6 service-right">
                            <div className="service-img w-100 mx-auto">
                              <img src={ServiceImg} alt="React Native Image" />
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="product-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title">
                <h4>Crafted for Excellence, Designed for You</h4>
                <h2>Our Product</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <p>
                  Discover our range of innovative products, thoughtfully
                  designed to meet your unique needs. Combining cutting-edge
                  technology with user-focused features, our products aim to
                  deliver unparalleled performance and reliability, empowering
                  you to achieve more with ease.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <Tab.Container defaultActiveKey="admin" className="mt-3 mt-lg-5">
            <Row className="mt-3 mt-lg-5">
              <Col>
                <Nav variant="tabs">
                  <div className="product-nav">
                    <Nav.Item>
                      <Nav.Link eventKey="admin">Admin</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="customer">Customer</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="delivery">Delivery</Nav.Link>
                    </Nav.Item>
                  </div>
                </Nav>
              </Col>
            </Row>
            <Row>
              <Col>
                <Tab.Content className="mt-5">
                  <Tab.Pane eventKey="admin">
                    <Slider {...sliderSettings1}>
                      {images1.admin.map((img, index) => (
                        <div key={index}>
                          <img
                            src={img}
                            alt={`Admin Slide ${index + 1}`}
                            style={{ width: "100%" }}
                          />
                        </div>
                      ))}
                    </Slider>
                  </Tab.Pane>
                  <Tab.Pane eventKey="customer">
                    <Slider {...sliderSettings2}>
                      {images1.customer.map((img, index) => (
                        <div key={index}>
                          <img
                            src={img}
                            alt={`Customer Slide ${index + 1}`}
                            style={{ width: "100%" }}
                          />
                        </div>
                      ))}
                    </Slider>
                  </Tab.Pane>
                  <Tab.Pane eventKey="delivery">
                    <Slider {...sliderSettings3}>
                      {images1.delivery.map((img, index) => (
                        <div key={index}>
                          <img
                            src={img}
                            alt={`Delivery Slide ${index + 1}`}
                            style={{ width: "100%" }}
                          />
                        </div>
                      ))}
                    </Slider>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div> */}

      {/* <div className="testimonial-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title">
                <h4>What Our Clients Say About Us</h4>
                <h2>Clients Testimonials</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <p>
                  Working with this team has been a game-changer for our
                  business. Their expertise, dedication, and innovative approach
                  helped us achieve results beyond our expectations. Highly
                  recommended!
                </p>
              </div>
            </div>
          </div>
          <div className="testimonial-slider mt-3 mt-lg-5">
            <Slider ref={sliderRef} {...sliderSettings}>
              {testimonials.map((testimonial) => (
                <div key={testimonial.id}>
                  <video controls>
                    <source src={testimonial.videoUrl} type="video/mp4" />
                  </video>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div> */}

      <div className="blog-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title">
                <h4>Insights, Ideas, and Innovations</h4>
                <h2>Our Blogs</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title">
                <p>
                  Explore our curated collection of blogs, where we share expert
                  insights, industry trends, and innovative ideas. From
                  practical tips to in-depth analyses, our blogs are designed to
                  inspire and keep you informed about the latest developments in
                  our field
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-0 mt-lg-5">
            <div className="col-lg-4">
              <div className="main-blog">
                <img src={BlogImg1} alt="Blog Image" />
                <div className="blog-content">
                  <h3>
                    Building the Future: How Our Mobile App Development Company
                    Turns Ideas into Reality
                  </h3>
                  <span>By Trupti Vora / Jan 08 2025</span>
                  <p>
                    In today’s fast-paced digital world, mobile applications
                    have become an essential tool for businesses to connect with
                    their customers, streamline operations, and stay ahead of
                    the competition. At CodeInfoWay, we are passionate about
                    bringing innovative ideas to life through our expertise in
                    mobile app development, with a special focus on the React
                    Native platform.
                  </p>
                  <Link to="/blog-detail" className="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="main-blog">
                <img src={BlogImg2} alt="Blog Image" />
                <div className="blog-content">
                  <h3>
                    Why React Native Is the Perfect Choice for Your Next Mobile
                    App
                  </h3>
                  <span>By Trupti Vora / Jan 08 2025</span>
                  <p>
                    In the ever-evolving world of mobile app development,
                    businesses face a crucial decision: which platform and
                    technology will best meet their needs? At CodeInfoWay, we
                    have found React Native to be the perfect solution for
                    creating dynamic, high-performing, and cost-effective mobile
                    applications. Here’s why React Native might be the ideal
                    choice for your next app.
                  </p>
                  <Link to="/blog-detail" className="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="main-blog">
                <img src={BlogImg3} alt="Blog Image" />
                <div className="blog-content">
                  <h3>
                    From Concept to Launch: Our Approach to Seamless Mobile App
                    Development
                  </h3>
                  <span>By Trupti Vora / Jan 08 2025</span>
                  <p>
                    At CodeInfoWay, we understand that creating a mobile
                    application is more than just coding. It’s about bringing a
                    vision to life, solving real-world problems, and delivering
                    exceptional user experiences. Our end-to-end development
                    process ensures that every app we build is not only
                    functional but also future-ready. Here’s a closer look at
                    how we turn your ideas into impactful mobile applications.
                  </p>
                  <Link to="/blog-detail" className="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cta-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2>Would you like to execute any project?</h2>
              <Link to="/contact-us" className="btn btn-primary mt-3">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
